(() => {
  if (window.CPDocumentLoader) return;
  const source = document.currentScript;
  const assets = { brochure: source.dataset.brochure, fonts: source.dataset.fonts };
  const pending = new Map();
  function load(key) {
    if (key === 'fonts' && window.CPDocumentFonts) return Promise.resolve(window.CPDocumentFonts);
    if (key === 'brochure' && window.CPFinishedBrochure && !window.CPFinishedBrochure.lazy) return Promise.resolve(window.CPFinishedBrochure);
    if (pending.has(key)) return pending.get(key);
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      let timer;
      function finish(error) {
        clearTimeout(timer);
        script.onload = script.onerror = null;
        if (error) { pending.delete(key); script.remove(); reject(error); return; }
        const api = key === 'fonts' ? window.CPDocumentFonts : window.CPFinishedBrochure;
        if (!api || (key === 'brochure' && api.lazy)) { pending.delete(key); script.remove(); reject(new Error('Document module unavailable')); return; }
        resolve(api);
      }
      script.src = assets[key];
      script.async = true;
      script.onload = () => finish();
      script.onerror = () => finish(new Error('Document module could not load'));
      timer = setTimeout(() => finish(new Error('Document module timed out')), 15000);
      document.head.append(script);
    });
    pending.set(key, promise);
    return promise;
  }
  const proxy = { lazy: true, scan: () => {} };
  ['create', 'createPlanningPack', 'createComparison'].forEach(method => {
    proxy[method] = async (...args) => (await load('brochure'))[method](...args);
  });
  if (!window.CPFinishedBrochure) window.CPFinishedBrochure = proxy;
  window.CPDocumentLoader = { ensureFonts: () => load('fonts'), ready: () => load('brochure') };
  // A click can arrive before the viewport observer has loaded the module.
  document.addEventListener('click', event => {
    const button = event.target.closest && event.target.closest('[data-cp-finish-download]');
    if (!button || button.dataset.bound) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.dataset.cpLoading) return;
    button.dataset.cpLoading = '1';
    const status = button.closest('[data-cp-finish-sheet]')?.querySelector('[data-cp-finish-status]');
    if (status) status.textContent = 'Loading the product document…';
    load('brochure').then(() => {
      delete button.dataset.cpLoading;
      if (button.dataset.bound) button.click();
      else if (status) status.textContent = 'Open the printable product page or ask us for this document.';
    }).catch(() => {
      delete button.dataset.cpLoading;
      if (status) status.textContent = 'The document could not load. Open the printable product page or try again.';
    });
  }, true);
  const observed = new WeakSet();
  const selector = '[data-cp-finish-sheet],[data-cp-download-library],[data-cp-document-library],[data-cp-resource-library],.cp-v29-library,.cp-v29-resources';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { observer.unobserve(entry.target); load('brochure').catch(() => {}); }
    });
  }, { rootMargin: '200px' }) : null;
  function scan(root = document) {
    root.querySelectorAll(selector).forEach(node => {
      if (observed.has(node)) return;
      observed.add(node);
      if (observer) observer.observe(node); else load('brochure').catch(() => {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
